// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39GIB","label":"styles_label__3JZBh"};